(function () {
  var defaultEndpoint = "https://hb-signup-code-service.vercel.app/api/back-in-stock";

  function getField(form, name) {
    return form.querySelector("[name='" + name + "']");
  }

  function fieldValue(form, name) {
    var field = getField(form, name);
    return field ? field.value.trim() : "";
  }

  function setStatus(form, message, type) {
    var status = form.querySelector("[data-hb-back-in-stock-status]");
    if (!status) return;
    status.hidden = false;
    status.textContent = message;
    status.dataset.status = type || "info";
    status.style.background = type === "error" ? "rgba(var(--color-error),0.14)" : "rgba(var(--color-success),0.14)";
  }

  function buttonLabel(button, text) {
    if (!button) return;
    var label = button.querySelector("[data-button-text]") || button.querySelector(".button-text") || button;
    label.textContent = text;
  }

  function submit(form, event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    }
    if (form.dataset.hbSubmitting === "true") return false;

    var emailInput = getField(form, "email");
    var email = emailInput ? emailInput.value.trim() : "";
    if (!email) {
      if (emailInput) emailInput.focus();
      setStatus(form, "Please enter your email address.", "error");
      return false;
    }

    var button = form.querySelector("button[type='submit']");
    var originalLabel = button ? button.textContent : "";
    form.dataset.hbSubmitting = "true";
    if (button) {
      button.disabled = true;
      buttonLabel(button, "Saving...");
    }
    setStatus(form, "Saving your request...", "info");

    fetch(form.dataset.endpoint || defaultEndpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        email: email,
        company: fieldValue(form, "company"),
        productId: form.dataset.productId || fieldValue(form, "product_id"),
        productGid: form.dataset.productGid || fieldValue(form, "product_gid"),
        productHandle: form.dataset.productHandle || fieldValue(form, "product_handle"),
        productTitle: form.dataset.productTitle || fieldValue(form, "product_title"),
        variantId: form.dataset.variantId || fieldValue(form, "variant_id"),
        variantGid: form.dataset.variantGid || fieldValue(form, "variant_gid"),
        variantTitle: form.dataset.variantTitle || fieldValue(form, "variant_title"),
        sku: form.dataset.sku || fieldValue(form, "sku"),
        productUrl: form.dataset.productUrl || fieldValue(form, "product_url"),
        imageUrl: form.dataset.imageUrl || fieldValue(form, "image_url"),
        pageUrl: window.location.pathname + window.location.search,
        source: "product_page",
      }),
    })
      .then(function (response) {
        return response.json().then(function (payload) {
          if (!response.ok || !payload.ok) throw new Error(payload.error || "Could not save this request.");
          return payload;
        });
      })
      .then(function (payload) {
        form.dataset.hbSubmitting = "false";
        setStatus(form, payload.message || form.dataset.success || "Thanks. We will email you as soon as this is back in season.", "success");
        if (button) {
          button.disabled = true;
          buttonLabel(button, "Saved");
        }
      })
      .catch(function (error) {
        form.dataset.hbSubmitting = "false";
        setStatus(form, error.message || "Sorry, we could not save this request. Please try again.", "error");
        if (button) {
          button.disabled = false;
          buttonLabel(button, originalLabel || "Send");
        }
      });

    return false;
  }

  document.addEventListener(
    "submit",
    function (event) {
      var form = event.target && event.target.closest ? event.target.closest("[data-hb-back-in-stock-form]") : null;
      if (form) submit(form, event);
    },
    true
  );
})();
